export default {
  /**
   * 店舗条件の標準フォーマット
   */
  get() {
    return {
      /**
       * 店舗グループ
       */
      storeGroup: undefined,
      /**
       * 店舗コード一覧
       */
      stores: [],
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(store) {
    return {
      storeGroup: store.storeGroup,
      stores: store.stores,
    }
  },
  /**
   * applyToに対してstoreを適用する
   */
  applyPayload(applyTo, store) {
    applyTo.storeGroup = store.storeGroup
    applyTo.stores = store.stores
  },
  summaryText(store) {
    return store.stores.length + '店舗'
  },
}
